import { lazy,Route } from '@tanstack/router'

import { newsRoute } from '.'

const NewsDetails = lazy(() => import('../../pages/news/news-details'))

export const newsDetailsRoute = new Route({
  getParentRoute: () => newsRoute,
  path: '$slug',
  component: NewsDetails,
})
